import request from '@/utils/request';

const CLIENT_RULE_API_PATH = '/api/ClientRule';

export const moduleState = {
  clientRules: [],
  clientRuleTypes: [],
  loading: false,
};

export const getters = {
  loading: state => state.loading,
  clientRuleTypes: state => state.clientRuleTypes,

  clientRules: (state, _getters, _rootState, rootGetters) => {
    return state.clientRules.map(rule => {
      const channelName = !rule.clientQuoteTypeId
        ? 'All'
        : rootGetters['channels/channelById'](rule.clientQuoteTypeId)?.name;
      return {
        ...rule,
        channelName,
      };
    });
  },
};

export const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },
  setClientRules(state, value) {
    state.clientRules = value;
  },
  setClientRuleTypes(state, value) {
    state.clientRuleTypes = value;
  },
};

export const actions = {
  async getClientRulesList({ commit, dispatch, rootState }) {
    dispatch(
      'channels/getChannelOverview',
      { clientId: rootState.client.client.id },
      { root: true }
    );

    const response = await request.get(CLIENT_RULE_API_PATH, {
      errorMessage: 'Failed to get client rules list.',
      loadingMutation: 'clientRules/setLoading',
    });

    if (!response) {
      return;
    }

    commit('setClientRules', response.data);
  },

  async getClientRuleTypesList({ commit }) {
    const response = await request.get(`${CLIENT_RULE_API_PATH}/types`, {
      errorMessage: 'Failed to get client rule types.',
      loadingMutation: 'clientRules/setLoading',
    });

    if (!response) {
      return;
    }

    commit('setClientRuleTypes', response.data);
  },

  async createClientRule({ dispatch }, rule) {
    const requestFn = rule.id ? request.put : request.post;
    const response = await requestFn(CLIENT_RULE_API_PATH, rule, {
      errorMessage: 'Failed to create client rule.',
      successMessage: 'Rule successfully created.',
      loadingMutation: 'clientRules/setLoading',
    });

    if (!response) {
      return false;
    }

    dispatch('getClientRulesList');

    return true;
  },

  async deleteClientRule({ dispatch }, rule) {
    const response = await request.delete(CLIENT_RULE_API_PATH, {
      data: rule,
      errorMessage: 'Failed to delete rule.',
      successMessage: 'Rule successfully deleted.',
      loadingMutation: 'clientRules/setLoading',
    });

    if (!response) {
      return;
    }

    dispatch('getClientRulesList');
  },
};
